// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';


//standard lightbox
const lightbox = GLightbox({
    autoplayVideos: true,
    plyr: {
        config: {
            autoplay: true,
            muted: true,
            clickToPlay: true,
            hideControls: false,
            youtube: {
                noCookie: true,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                autoplay: 1,
                mute: 1
            },
            vimeo: {
                autoplay: true,
                muted: true,
                byline: false,
                portrait: false,
                title: false
            }
        }
    },
    videosWidth: '960px'
});

// Handle video autoplay for Safari/iOS
lightbox.on('slide_changed', ({ prev, current }) => {
    const iframe = current.slideNode.querySelector('iframe');
    if (iframe && iframe.src.includes('youtube')) {
        // Wait a bit for the iframe to load, then try to play
        setTimeout(() => {
            const player = current.slideNode.querySelector('.plyr');
            if (player && player.plyr) {
                player.plyr.muted = true;
                player.plyr.play().catch(() => {
                    // If autoplay fails, user will need to click play
                    console.log('Autoplay prevented - user interaction required');
                });
            }
        }, 500);
    }
});

//search box header
$(document).ready(function() {

    const searchbox = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".searchboxlink",
        zoomable: false,
        draggable: false,
        height: 'auto'
    });
    searchbox.on('open', () => {
        $('input[type="search"]').select();
        $('.button--close').click(function() {
            searchbox.close();
        })
    });

});
